import { Badge } from './PromoBadge.styled';

interface PromoBadgeProps {
  altText: string;
  src: string;
}

export const PromoBadge = ({ altText, src }: PromoBadgeProps) => (
  <Badge>
    <img alt={altText} src={src} />
  </Badge>
);
